import React from "react";

import { IconSize } from "../../enums";
import { BusyIconWrapper } from "./BusyIndicator.styles";
import { ReactComponent as BusyXSSvg } from "./loaders/busyXS.svg"; // origName: animace/loaders/svg/vcela_XS_Kreslicí plátno 1_Kreslicí plátno 1.svg

interface IBusyIconProps {
    size?: string;
}


// Separated BusyIcon to prevent circular imports (from BusyIndicator). 
// Causes circular import because of LoadingError importing button and button is newly using withErrorAndTooltip
// the circular import pattern is following:
// WithErrorAndTooltip.ts ,FormError.tsx, Icon.tsx, BusyIndicator.tsx, LoadingError.tsx ,Button.tsx, WithErrorAndTooltip.tsx
export class BusyIcon extends React.PureComponent<IBusyIconProps> {
    static defaultProps: Partial<IBusyIconProps> = {
        size: IconSize.XS,
    };

    render() {
        return (
            <BusyIconWrapper>
                <BusyXSSvg width={this.props.size} height={this.props.size}/>
            </BusyIconWrapper>
        );
    }
}
